import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'customer-app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgStyle, TranslatePipe]
})
export class IntroComponent {
  private readonly translateService = inject(TranslateService);

  readonly maxHeight = input<string>(undefined);

  get textContent(): string {
    return this.translateService.instant('guided-tour.intro-text');
  }
}
